import React from 'react';
import { useParams, useHistory } from "react-router-dom";
import EntityForm from './EntityFormComponent';
import { putEntity } from '../routing/routes';

const EditarEntity = ({entities, setNotification, refreshData}) => {
    const { id } = useParams();
    const history = useHistory();
    const entity = entities.find(entity => entity._id === id)
    function guardarEntity(nuevoEntity){
        const data = {entity: nuevoEntity.entity, subentities: nuevoEntity.subentities}
        putEntity(nuevoEntity._id, data)
        .then(() => {
            refreshData()
            history.push("/training")
            setNotification("mEntity editado correctamente!")
        })
        .catch(error => {
            setNotification("eOcurrió un error editando el entity!");
            console.error('Error:', error)
        })
    }
    if (entity){
        return <EntityForm entity={entity} entities={entities} guardarEntity={guardarEntity} history={history} editing={true}/>
    } else {
        return <p>Loading...</p>
    }
}

export default EditarEntity